import { render, staticRenderFns } from "./ClaimsMovement.vue?vue&type=template&id=c25e79ec&"
import script from "./ClaimsMovement.vue?vue&type=script&lang=js&"
export * from "./ClaimsMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports